module.exports = __webpack_public_path__ + "img/phone.e5385147.svg";